<div class="certificate-container" id="certificate">

    <!-- Header with Chevron Patterns -->
    <div class="header-section">
        <!-- Left Chevron Pattern -->
        <svg class="chevron-pattern" viewBox="0 0 180 80">
            <defs>
                <radialGradient id="dotGrad" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" style="stop-color:#c5a059;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#c5a059;stop-opacity:0.2" />
                </radialGradient>
            </defs>
            <!-- Dot Pattern Logic: Rows and columns of dots forming arrows -->
            <g fill="#c5a059">
                <!-- First Arrow -->
                <circle cx="20" cy="40" r="2.5" />
                <circle cx="30" cy="30" r="2.5" /> <circle cx="30" cy="50" r="2.5" />
                <circle cx="40" cy="20" r="2.5" /> <circle cx="40" cy="40" r="2.5" /> <circle cx="40" cy="60" r="2.5" />
                <circle cx="50" cy="10" r="2" opacity="0.6" /> <circle cx="50" cy="30" r="2.5" /> <circle cx="50" cy="50" r="2.5" /> <circle cx="50" cy="70" r="2" opacity="0.6" />
                <circle cx="60" cy="20" r="2.5" /> <circle cx="60" cy="40" r="2.5" /> <circle cx="60" cy="60" r="2.5" />

                <!-- Second Arrow -->
                <circle cx="80" cy="40" r="2.5" />
                <circle cx="90" cy="30" r="2.5" /> <circle cx="90" cy="50" r="2.5" />
                <circle cx="100" cy="20" r="2.5" /> <circle cx="100" cy="40" r="2.5" /> <circle cx="100" cy="60" r="2.5" />
                <circle cx="110" cy="10" r="2.5" /> <circle cx="110" cy="30" r="2.5" /> <circle cx="110" cy="50" r="2.5" /> <circle cx="110" cy="70" r="2.5" />
                <circle cx="120" cy="20" r="2.5" /> <circle cx="120" cy="40" r="2.5" /> <circle cx="120" cy="60" r="2.5" />
            </g>
        </svg>

        <div class="title-block">
            <h1 class="main-title">CERTIFICATE</h1>
            <div class="sub-title">OF COMPLETION</div>
        </div>

        <!-- Right Chevron Pattern (Mirrored) -->
        <svg class="chevron-pattern" viewBox="0 0 180 80" style="transform: scaleX(-1);">
            <g fill="#c5a059">
                <circle cx="20" cy="40" r="2.5" />
                <circle cx="30" cy="30" r="2.5" /> <circle cx="30" cy="50" r="2.5" />
                <circle cx="40" cy="20" r="2.5" /> <circle cx="40" cy="40" r="2.5" /> <circle cx="40" cy="60" r="2.5" />
                <circle cx="50" cy="10" r="2" opacity="0.6" /> <circle cx="50" cy="30" r="2.5" /> <circle cx="50" cy="50" r="2.5" /> <circle cx="50" cy="70" r="2" opacity="0.6" />
                <circle cx="60" cy="20" r="2.5" /> <circle cx="60" cy="40" r="2.5" /> <circle cx="60" cy="60" r="2.5" />

                <circle cx="80" cy="40" r="2.5" />
                <circle cx="90" cy="30" r="2.5" /> <circle cx="90" cy="50" r="2.5" />
                <circle cx="100" cy="20" r="2.5" /> <circle cx="100" cy="40" r="2.5" /> <circle cx="100" cy="60" r="2.5" />
                <circle cx="110" cy="10" r="2.5" /> <circle cx="110" cy="30" r="2.5" /> <circle cx="110" cy="50" r="2.5" /> <circle cx="110" cy="70" r="2.5" />
                <circle cx="120" cy="20" r="2.5" /> <circle cx="120" cy="40" r="2.5" /> <circle cx="120" cy="60" r="2.5" />
            </g>
        </svg>
    </div>

    <div class="certify-text">THIS IS TO CERTIFY THAT</div>

    <div class="student-name">Student Name</div>

    <p class="description">
        has successfully completed the online course <b>'English Vocabulary'</b><br>
        Throughout the online program, the participant demonstrated active participation, conceptual<br>
        understanding, and successful completion of required assignments and assessments, in alignment<br>
        with the course objectives.
    </p>

    <!-- Footer Section -->
    <div class="footer-section">
        <div class="footer-item">
            <span class="label">DATE OF ISSUE</span>
            <span class="value">{{ currentDate }}</span>
        </div>

        <div class="seal-container">
            <svg class="seal-svg" viewBox="0 0 100 100">
                <path d="M50 5 L58 15 L70 12 L75 25 L88 28 L85 40 L95 50 L85 60 L88 72 L75 75 L70 88 L58 85 L50 95 L42 85 L30 88 L25 75 L12 72 L15 60 L5 50 L15 40 L12 28 L25 25 L30 12 L42 15 Z" fill="#c5a059" />
                <circle cx="50" cy="50" r="30" fill="white" opacity="0.2" />
                <!-- Ribbon tails -->
                <path d="M40 85 L30 100 L50 92 L70 100 L60 85" fill="#c5a059" />
            </svg>
        </div>

        <div class="footer-item">
            <div class="signature-container">
                <svg width="100" height="40" viewBox="0 0 100 40">
                    <path d="M10 30 Q 30 10 40 30 T 70 20 T 90 30" fill="none" stroke="#1f2937" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <span class="label">SIGNATURE</span>
        </div>
    </div>

</div>

